module.exports = __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/apple_podcasts-20def131d2139e5162c10157088df399.svg";